import React from 'react'
import { FaShoppingCart } from 'react-icons/fa'
import { useTranslation } from 'context/LanguageContext'; 

const CartButton = ({ cartCount, cartStatus, setHide }) => {
  const { t } = useTranslation();
  
  return (
    <button 
      onClick={() => cartStatus(true)}
      className="relative hover:opacity-80 transition text-center"
    >
      <FaShoppingCart className="w-6 h-6 text-blue-600 mx-auto" />
      {cartCount > 0 && (
        <span className="absolute -top-1 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
          {cartCount}
        </span>
      )}
      {!setHide && (
        <span className="text-sm text-gray-700">{t('cart')}</span>
      )}
    </button>
  )
}

export default CartButton;
